// utils/urlHelpers.js

// Safe function to extract and validate email from URL
export const getEmailFromURL = () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get('email');

        // Basic validation to prevent XSS - only allow valid email format
        if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            // Additional safety: limit length and ensure no HTML/script content
            if (email.length <= 254 && !/[<>'"&]/.test(email)) {
                return email;
            }
        }
        return '';
    } catch (error) {
        console.error('Error parsing URL parameters:', error);
        return '';
    }
};